import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Reverse engineer a GraphQL API to automate love notes – CodeWithSwiz 24",
  "description": "We used a man-in-the-middle attack to snoop an app's API traffic, replayed it in a GraphQL client, and successfully put it inside an AWS Lambda 🤘",
  "categories": "CodeWithSwiz, Technical, GraphQL, Serverless, AWS Lambda, Livecoding",
  "published": "2021-02-23T00:00:00.000Z",
  "hero": "./img/screenshot-1614094888525.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Epic stream Friend! We used a man-in-the-middle attack to snoop an app's API traffic, replayed it in a GraphQL client, and successfully put it inside an AWS Lambda 🤘`}</p>
    <p><em parentName="p">{`CodeWithSwiz is a weekly live show. Like a podcast with video and fun hacking. Focused on experiments and open source. `}<a parentName="em" {...{
          "href": "https://youtube.com/swizecteller"
        }}>{`Join live most Mondays`}</a></em></p>
    <p>{`For Valentine's day The Girl got a `}<a parentName="p" {...{
        "href": "https://en.lovebox.love/"
      }}>{`Lovebox`}</a>{` – an IoT device that accepts love notes, spins a 3D printed heart, and shows your note on a color screen. She loved it. 😍`}</p>
    <p>{`And you know how this goes, right?`}</p>
    <p>{`Day 1: Send 20 notes`}</p>
    <p>{`Day 2: Send 2 notes`}</p>
    <p>{`Day 3:`}</p>
    <p>{`Day 4:`}</p>
    <p>{`...`}</p>
    <p>{`But if you could automate it to send cute notes and pictures from your relationship at random intervals 🤔`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Got a thing for The Girl. `}<br parentName="p"></br><br parentName="p"></br>{`It’s a box that receives love notes and photos. And there’s an API. Gonna lovecode a idea tomorrow ✌️ `}<a parentName="p" {...{
          "href": "https://t.co/1PAFENFydc"
        }}>{`pic.twitter.com/1PAFENFydc`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1361141468803461121"
      }}>{`February 15, 2021`}</a></blockquote>
    <h2 {...{
      "id": "the-plan"
    }}>{`The plan`}</h2>
    <p>{`Lovebox's marketing team says `}<em parentName="p">{`"Send notes to your Lovebox from an app, it's cute and awesome and shows Your Person you thought of them!"`}</em></p>
    <p>{`As a nerd that reads: `}<em parentName="p">{`"We have an API."`}</em></p>
    <p>{`How else would it work? There must be a server. Apps send API requests to the server, server reads a lookup table, sends message to the box – a tiny computer – through another API.`}</p>
    <ol>
      <li parentName="ol">{`Read API traffic from app to server`}</li>
      <li parentName="ol">{`Find request that sends a message`}</li>
      <li parentName="ol">{`Replay request`}</li>
      <li parentName="ol">{`Create AWS Lambda that runs on schedule`}</li>
      <li parentName="ol">{`Send random notes`}</li>
    </ol>
    <h2 {...{
      "id": "step-0-fail-to-hack-the-api"
    }}>{`Step 0: Fail to hack the API`}</h2>
    <lite-youtube {...{
      "videoid": "ndLGFx7U--w",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Lovebox has a webapp and that's a great first target. Log into the app, open Chrome's network tab, see a tonne of graphql requests, send a message.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/91e4a02379f1e13cb6a4d64ed981c69f/c02c7/Graphql-requests-that-Lovebox-sendsb18ec0.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "26.008968609865473%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'104\\'%20viewBox=\\'0%200%20400%20104\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2053v4h122v-8H0v4m0%2050\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/91e4a02379f1e13cb6a4d64ed981c69f/ca0a1/Graphql-requests-that-Lovebox-sendsb18ec0.webp 223w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/75680/Graphql-requests-that-Lovebox-sendsb18ec0.webp 445w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/8d1ba/Graphql-requests-that-Lovebox-sendsb18ec0.webp 890w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/3838e/Graphql-requests-that-Lovebox-sendsb18ec0.webp 1335w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/e11e5/Graphql-requests-that-Lovebox-sendsb18ec0.webp 1780w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/c3ac5/Graphql-requests-that-Lovebox-sendsb18ec0.webp 2472w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/91e4a02379f1e13cb6a4d64ed981c69f/e92b6/Graphql-requests-that-Lovebox-sendsb18ec0.png 223w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/e66bf/Graphql-requests-that-Lovebox-sendsb18ec0.png 445w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/4ef49/Graphql-requests-that-Lovebox-sendsb18ec0.png 890w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/4e814/Graphql-requests-that-Lovebox-sendsb18ec0.png 1335w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/701e9/Graphql-requests-that-Lovebox-sendsb18ec0.png 1780w", "/static/91e4a02379f1e13cb6a4d64ed981c69f/c02c7/Graphql-requests-that-Lovebox-sendsb18ec0.png 2472w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/91e4a02379f1e13cb6a4d64ed981c69f/4ef49/Graphql-requests-that-Lovebox-sendsb18ec0.png",
                "alt": "Graphql requests that Lovebox sends",
                "title": "Graphql requests that Lovebox sends",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Graphql requests that Lovebox sends`}</figcaption>{`
  `}</figure></p>
    <p>{`We got it!`}</p>
    <p>{`Alas, the webapp doesn't work with v2 of the Lovebox. Old API, no support for color. When you click the upgrade button your box can get color pictures, but not requests from the old API. 💩`}</p>
    <p>{`Snooping iOS traffic stumped us.`}</p>
    <h2 {...{
      "id": "step-1-use-charles-proxy-to-snoop-ios-traffic"
    }}>{`Step 1: Use Charles Proxy to snoop iOS traffic`}</h2>
    <lite-youtube {...{
      "videoid": "cvvPLlP4518",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Off stream I discovered `}<a parentName="p" {...{
        "href": "https://www.charlesproxy.com/"
      }}>{`Charles Proxy`}</a>{`, a tool for "debugging" web traffic.`}</p>
    <p>{`You run the app on your phone, enable proxying, set up SSL proxy, and use the Lovebox app. Charles Proxy convinces your iOS networking layer to send every request through the app.`}</p>
    <p>{`SSL proxying is important. It lets you read the content of encrypted https connections and the target app doesn't even notice. Classic `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Man-in-the-middle_attack"
      }}>{`man-in-the-middle`}</a>{` attack.`}</p>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/cvvPLlP4518?t=679"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "51.569506726457405%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'207\\'%20viewBox=\\'0%200%20400%20207\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M119%201v8l-1%208v2l1%2042v43h-16a395%20395%200%2001-50%201l-10%201-1%207c0%204-1%207-2%207-1%201-1%203%201%203v3l1%201c0%201-3%201-4-1-2-2-3-1-3%206v7H0v68h401v-35l-1-29a305%20305%200%2000-2%2040l-21-1-20%201v9h19l20%201h2c1-1%201-1%201%201v3l-85-1a992%20992%200%2001-86-2l-1-14-1-97a1329%201329%200%2000-3%2088v26H122V98c0-100%200-101-3-97\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c71d44eeae54299b723ba80bdfd80930/ca0a1/List-of-API-requests-in-Charles-Proxy1f47e3.webp 223w", "/static/c71d44eeae54299b723ba80bdfd80930/75680/List-of-API-requests-in-Charles-Proxy1f47e3.webp 445w", "/static/c71d44eeae54299b723ba80bdfd80930/8d1ba/List-of-API-requests-in-Charles-Proxy1f47e3.webp 890w", "/static/c71d44eeae54299b723ba80bdfd80930/3838e/List-of-API-requests-in-Charles-Proxy1f47e3.webp 1335w", "/static/c71d44eeae54299b723ba80bdfd80930/e11e5/List-of-API-requests-in-Charles-Proxy1f47e3.webp 1780w", "/static/c71d44eeae54299b723ba80bdfd80930/a9001/List-of-API-requests-in-Charles-Proxy1f47e3.webp 2748w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c71d44eeae54299b723ba80bdfd80930/e92b6/List-of-API-requests-in-Charles-Proxy1f47e3.png 223w", "/static/c71d44eeae54299b723ba80bdfd80930/e66bf/List-of-API-requests-in-Charles-Proxy1f47e3.png 445w", "/static/c71d44eeae54299b723ba80bdfd80930/4ef49/List-of-API-requests-in-Charles-Proxy1f47e3.png 890w", "/static/c71d44eeae54299b723ba80bdfd80930/4e814/List-of-API-requests-in-Charles-Proxy1f47e3.png 1335w", "/static/c71d44eeae54299b723ba80bdfd80930/701e9/List-of-API-requests-in-Charles-Proxy1f47e3.png 1780w", "/static/c71d44eeae54299b723ba80bdfd80930/990be/List-of-API-requests-in-Charles-Proxy1f47e3.png 2748w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c71d44eeae54299b723ba80bdfd80930/4ef49/List-of-API-requests-in-Charles-Proxy1f47e3.png",
                "alt": "List of API requests in Charles Proxy",
                "title": "List of API requests in Charles Proxy",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`List of API requests in Charles Proxy`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You get a request trace that you can export to the Charles Proxy desktop app.`}</p>
    <h2 {...{
      "id": "step-2-dig-through-the-api-trace"
    }}>{`Step 2: Dig through the API trace`}</h2>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/f902c8e2948aa23cf05c42c4f0f4015e/7e9b1/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "73.09417040358744%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'293\\'%20viewBox=\\'0%200%20400%20293\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2032c0%2028%200%2032%202%2032l1%201c-1%201%200%202%201%204%201%203%201%203-1%205l-3%202v79a1198%201198%200%20001%2080l-1%2029v29h401V158l-4-1-2-2-1-1c-1%201-2%200-2-1l2-1%201%201h2c2%200%203%200%203%202l1-76V0h-57c-56%200-56%200-56%202%200%203-4%203-5%200%200-2-5-3-5-1l-1%203-1-2c1-2-1-3-2-1h-2l-59-1c-58%200-59%200-59%202-1%203-5%203-6%200s-27-3-29%200c-1%203-5%203-6%200%200-2-1-2-57-2H0v32M13%208c-3%200-3%2026-3%20157l1%20118%20190%201%20188-1c2-1%201-273%200-275-1-1-371-2-376%200m190%203h-9l-5%201c0%202%2045%202%2046%200l-4-1a4220%204220%200%2001-23%201h-2l-3-1m68%2020l3%201h4a708%20708%200%200032-2h-25c-1-1-14-1-14%201M43%2040v3h30v-6H43v3m-1%2063v3h30v-5l-15-1H42v3m135%2088l1%204h32v-8h-33v4m-42%2078v3h33v-7h-33v4m228%208c-1%205%200%206%2012%206h12v-7h-11l-13%201\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f902c8e2948aa23cf05c42c4f0f4015e/ca0a1/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.webp 223w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/75680/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.webp 445w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/8d1ba/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.webp 890w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/3838e/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.webp 1335w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/e11e5/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.webp 1780w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/ffd3e/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.webp 2252w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/f902c8e2948aa23cf05c42c4f0f4015e/e92b6/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.png 223w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/e66bf/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.png 445w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/4ef49/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.png 890w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/4e814/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.png 1335w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/701e9/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.png 1780w", "/static/f902c8e2948aa23cf05c42c4f0f4015e/7e9b1/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.png 2252w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/f902c8e2948aa23cf05c42c4f0f4015e/4ef49/Dig-through-API-trace-in-Charles-Proxy-desktopg3gi2g.png",
                "alt": "Dig through API trace in Charles Proxy desktop",
                "title": "Dig through API trace in Charles Proxy desktop",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Dig through API trace in Charles Proxy desktop`}</figcaption>{`
  `}</figure></p>
    <p>{`We dug through the trace and found the GraphQL request that sends a note – `}<inlineCode parentName="p">{`sendPixNote2`}</inlineCode>{`.`}</p>
    <p>{`Looks like every note is sent as a base64-encoded PNG image. We tried pictures and text and they all looked like this.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`recipient`}</inlineCode>{` must be my Lovebox's ID, `}<inlineCode parentName="p">{`contentType`}</inlineCode>{` needs further exploration but `}<inlineCode parentName="p">{`["Text"]`}</inlineCode>{` and `}<inlineCode parentName="p">{`["Image"]`}</inlineCode>{` both worked, and `}<inlineCode parentName="p">{`deviceId`}</inlineCode>{` looks like my phone. Not sure that's important.`}</p>
    <p>{`GraphQL `}<del parentName="p">{`query`}</del>{` mutation in the request looks like this:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation sendPixNote(
  $base64: String
  $recipient: String
  $date: Date
  $options: JSON
  $contentType: [String]
) {
  sendPixNote(
    base64: $base64
    recipient: $recipient
    date: $date
    options: $options
    contentType: $contentType
  ) {
    _id
    type
    recipient
    url
    date
    status {
      label
      __typename
    }
    base64
    __typename
  }
}
`}</code></pre>
    <p>{`Nice thing about reverse-engineering GraphQL is that every request tells you what it's doing. Downside is you have to click on every request because they're all to the same endpoint.`}</p>
    <h2 {...{
      "id": "step-3-replay-requests-in-graphql-client"
    }}>{`Step 3: Replay requests in GraphQL client`}</h2>
    <p>{`Before you start coding, you gotta verify you can hack the API. We used a `}<a parentName="p" {...{
        "href": "https://github.com/graphql/graphql-playground"
      }}>{`desktop GraphQL Client`}</a>{`.`}</p>
    <p>{`Start easy, can you send requests at all?`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/eb33e7980c0891903579c3a47fe68abb/53948/Our-first-hacked-request5ihb41.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "65.02242152466367%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'260\\'%20viewBox=\\'0%200%20400%20260\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M26%2013c-2%201-2%204-2%2018a371490%20371490%200%20000%20174v16h28v12c0%2014%200%2016%203%2016l2-1v-1l2%201a2941%202941%200%2001163-1l153-1c2%200%202-11%202-117V12h-2a13076%2013076%200%2000-349%201m171%2036c-7%206-4%2016%205%2016%207%200%2011-9%206-15-3-2-8-3-11-1\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/eb33e7980c0891903579c3a47fe68abb/ca0a1/Our-first-hacked-request5ihb41.webp 223w", "/static/eb33e7980c0891903579c3a47fe68abb/75680/Our-first-hacked-request5ihb41.webp 445w", "/static/eb33e7980c0891903579c3a47fe68abb/8d1ba/Our-first-hacked-request5ihb41.webp 890w", "/static/eb33e7980c0891903579c3a47fe68abb/3838e/Our-first-hacked-request5ihb41.webp 1335w", "/static/eb33e7980c0891903579c3a47fe68abb/e11e5/Our-first-hacked-request5ihb41.webp 1780w", "/static/eb33e7980c0891903579c3a47fe68abb/36600/Our-first-hacked-request5ihb41.webp 2720w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/eb33e7980c0891903579c3a47fe68abb/e92b6/Our-first-hacked-request5ihb41.png 223w", "/static/eb33e7980c0891903579c3a47fe68abb/e66bf/Our-first-hacked-request5ihb41.png 445w", "/static/eb33e7980c0891903579c3a47fe68abb/4ef49/Our-first-hacked-request5ihb41.png 890w", "/static/eb33e7980c0891903579c3a47fe68abb/4e814/Our-first-hacked-request5ihb41.png 1335w", "/static/eb33e7980c0891903579c3a47fe68abb/701e9/Our-first-hacked-request5ihb41.png 1780w", "/static/eb33e7980c0891903579c3a47fe68abb/53948/Our-first-hacked-request5ihb41.png 2720w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/eb33e7980c0891903579c3a47fe68abb/4ef49/Our-first-hacked-request5ihb41.png",
                "alt": "Our first hacked request",
                "title": "Our first hacked request",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Our first hacked request`}</figcaption>{`
  `}</figure></p>
    <p>{`Add an authorization header with a JWT token `}<inlineCode parentName="p">{`Authorization: Bearer ...`}</inlineCode>{` – copypasta'd from our API trace – use the right GraphQL endpoint, and press play.`}</p>
    <p>{`it worked 🎉`}</p>
    <h2 {...{
      "id": "step-4-your-first-modified-request"
    }}>{`Step 4: Your first modified request`}</h2>
    <p>{`We tried a few more requests and confirmed that sending works. `}<inlineCode parentName="p">{`sendPixNote`}</inlineCode>{` using the same data made our heart spin.`}</p>
    <p><img parentName="p" {...{
        "src": "/1be9b52536457e586fd00283c91f7e40/Lovebox-spins79fjai.gif",
        "alt": "Lovebox spins!"
      }}></img></p>
    <p>{`Fantastic! Now you know it's gonna work.`}</p>
    <p>{`Next we tried a modified request with a custom payload. Found an image online, converted to base64, pasta'd in there.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/88067192e36925ad57750e04582dbdd4/72923/The-first-modified-write-requestf4688e.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.22869955156951%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'253\\'%20viewBox=\\'0%200%20400%20253\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20126l1%20127h397l1-2c0-2%200-2%201-1a4537%204537%200%20000-242l-1%209V1L199%200H0v126m399-84v24h-8v20h4c3%200%204%200%204%202s-1%202-4%202h-4v12l1%2013h7v23l1-49a2624%202624%200%2000-1-47m-170-3c-6%204-7%2011-2%2015%204%204%209%204%2013%200%208-7-2-20-11-15\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/88067192e36925ad57750e04582dbdd4/ca0a1/The-first-modified-write-requestf4688e.webp 223w", "/static/88067192e36925ad57750e04582dbdd4/75680/The-first-modified-write-requestf4688e.webp 445w", "/static/88067192e36925ad57750e04582dbdd4/8d1ba/The-first-modified-write-requestf4688e.webp 890w", "/static/88067192e36925ad57750e04582dbdd4/3838e/The-first-modified-write-requestf4688e.webp 1335w", "/static/88067192e36925ad57750e04582dbdd4/e11e5/The-first-modified-write-requestf4688e.webp 1780w", "/static/88067192e36925ad57750e04582dbdd4/6871c/The-first-modified-write-requestf4688e.webp 3114w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/88067192e36925ad57750e04582dbdd4/e92b6/The-first-modified-write-requestf4688e.png 223w", "/static/88067192e36925ad57750e04582dbdd4/e66bf/The-first-modified-write-requestf4688e.png 445w", "/static/88067192e36925ad57750e04582dbdd4/4ef49/The-first-modified-write-requestf4688e.png 890w", "/static/88067192e36925ad57750e04582dbdd4/4e814/The-first-modified-write-requestf4688e.png 1335w", "/static/88067192e36925ad57750e04582dbdd4/701e9/The-first-modified-write-requestf4688e.png 1780w", "/static/88067192e36925ad57750e04582dbdd4/72923/The-first-modified-write-requestf4688e.png 3114w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/88067192e36925ad57750e04582dbdd4/4ef49/The-first-modified-write-requestf4688e.png",
                "alt": "The first modified write request",
                "title": "The first modified write request",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`The first modified write request`}</figcaption>{`
  `}</figure></p>
    <p>{`Apollo's GraphQL Playground client lets you do that by changing variables bottom left. Much easier than futzing around with REST.`}</p>
    <p>{`And the Lovebox displayed a blue fish.`}</p>
    <p><a parentName="p" {...{
        "href": "https://youtu.be/cvvPLlP4518?t=2215"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "56.50224215246637%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'225\\'%20viewBox=\\'0%200%20400%20225\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M156%202l10%201h10l-2%203-3%203-22-1a201%20201%200%2001-28-2c-1-1%200-1%202-1l-2-1-63-1H0v222h401V2l-1-2H280a1829%201829%200%2000-124%202m84%203l-1%201-4%202-5%203c-4%200-4%202-2%205l2%203c0%202%203%204%205%203%203%200%203%201%204%2010%200%209%200%2011%203%2012l4%202%202%202v-2c0-2%203-3%206-1%202%201%202%202%202%2011%200%2010-1%2013-4%2013v10l1%202%203%207c3%207%201%2015-3%2015-2%200-6-7-7-11s-1-4-2-2l-9%2016c-3%204-3%205-3%209l-2%209-2%205c0%204-2%202-3-3v-4l-1%206c-1%204-1%207-3%209-3%203-5%2011-4%2013%201%201%205-3%206-6%200-5%202-9%203-9l1%207c3%2033%203%2033%205%2029v-8c-2-5-2-10%200-12%203-2%201-16-2-16-4%200%201-10%205-10a400%20400%200%200180-5c2%202%203%206%201%206v20c3%2025%203%2027%205%2027l1%203-1%202-1%203c0%202%200%202%201%201%201-2%201-2%201%201v6l1%202v1l1%202c0%202-89%202-92-1-2-1-2-2-1-4l1-2%201-3v-4l-3-3c-2-6-3-3-3%207l1%2011H121a2219%202219%200%200084%202%20608%20608%200%2001115%204c-2%203-7%204-19%204-10%200-12%201-12%203%201%203%2026%204%2034%201l11-1a694%20694%200%200010%204c0%201%201%202%206%202%206%200%206%200%206%202s1%203%202%203h1c0-3%204-4%2020-4h16v-13c0-4%201-5%203-5%203%200%203-2%200-2l-2-2a6690%206690%200%2000-1-130V3h-77c-68%200-77%200-78%202m-93%2037c-5%203-6%205-5%207l-1%206-2%209-1%205-1%202c-1%202%201%203%202%201%201-1%2018%200%2020%201l1%201h2l1%203%203%204c3%204%205%209%204%2012-2%204%200%205%205%206%206%200%206-1%202-4-3-3-3-3-1-3l4-1%2013-3c9%200%2010%200%2015%202l7%203c3%200%206%205%206%208v2l1-3%203-9c2-6%202-14%201-14l-2%202c-2%203-3%202-5-5%200-4-2-7-3-9l-2-4-2-2-2-2c0-7-24-17-35-16h-10c-13-2-14-2-18%201m23%2063l-1%206a80%2080%200%2001-5%2020l12%205%207%202c3%201%203-5%200-7-2-1-2-3-3-6%200-16-5-25-10-20m-39%204l1%204%201%204c2%207%2016%206%2025-1%203-3%204-7%202-9s-5-3-5-1l-5%201-6-1-7-1h-6v4m52-2c-2%204-1%2013%202%2017%208%2011%2026%2012%2032%202%202-4%202-10-1-10l-4-2c-8-5-10-5-10-1%200%203-2%203-8%202-5-2-9-6-9-9%201-2-1-1-2%201m86%201c-2%205-2%2010%201%209h5c4%200%204-5%200-9s-5-4-6%200m-52%2022c-3%203-8%205-13%205-3%200-4%200-4%202%200%201%200%202-3%202-4%202-4%203%201%205l4%204c2%206%2012-4%2016-15%202-6%202-7-1-3m-31%2012c-4%203-4%204%200%208%203%203%206%205%209%205v-1l-1-3c1-3%200-4-2-7l-4-4-2%202m83%2010c-4%202-8%206-6%206l4%205%203%204-3%204c-4%204-4%205%202%208s20-1%2023-7c2-3%203-3%205-2%202%200%202%200%202-3l-1-5c0-3%200-3-2-3-3%201-8-3-6-5%201-1%201-1-1-1-1%201-4%200-7-1h-13\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6960f71d97b94a3bf7a0c09261914ea0/ca0a1/Blue-fish-on-the-boxd3dgf5.webp 223w", "/static/6960f71d97b94a3bf7a0c09261914ea0/75680/Blue-fish-on-the-boxd3dgf5.webp 445w", "/static/6960f71d97b94a3bf7a0c09261914ea0/8d1ba/Blue-fish-on-the-boxd3dgf5.webp 890w", "/static/6960f71d97b94a3bf7a0c09261914ea0/3838e/Blue-fish-on-the-boxd3dgf5.webp 1335w", "/static/6960f71d97b94a3bf7a0c09261914ea0/a7511/Blue-fish-on-the-boxd3dgf5.webp 1570w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/6960f71d97b94a3bf7a0c09261914ea0/e92b6/Blue-fish-on-the-boxd3dgf5.png 223w", "/static/6960f71d97b94a3bf7a0c09261914ea0/e66bf/Blue-fish-on-the-boxd3dgf5.png 445w", "/static/6960f71d97b94a3bf7a0c09261914ea0/4ef49/Blue-fish-on-the-boxd3dgf5.png 890w", "/static/6960f71d97b94a3bf7a0c09261914ea0/4e814/Blue-fish-on-the-boxd3dgf5.png 1335w", "/static/6960f71d97b94a3bf7a0c09261914ea0/08c33/Blue-fish-on-the-boxd3dgf5.png 1570w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/6960f71d97b94a3bf7a0c09261914ea0/4ef49/Blue-fish-on-the-boxd3dgf5.png",
                "alt": "Blue fish on the box",
                "title": "Blue fish on the box",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Blue fish on the box`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Huzzah!`}</p>
    <h2 {...{
      "id": "step-5-copy-request-into-an-aws-lambda"
    }}>{`Step 5: Copy request into an AWS Lambda`}</h2>
    <p>{`Request works, next we gotta move into a Lambda. We used Prisma's minimalist `}<a parentName="p" {...{
        "href": "https://github.com/prisma-labs/graphql-request"
      }}>{`graphql-request`}</a>{` library.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-typescript"
      }}>{`// src/lovebox.ts

import { request, gql, GraphQLClient } from "graphql-request"

const client = new GraphQLClient("https://app-api.loveboxlove.com/v1/graphql", {
  headers: {
    // TODO: figure out how to login
    Authorization: "Bearer ...",
  },
})

// copypasta the variables
const variables = {
  base64: \`data:image/png;base64,...\`,
  recipient: "...",
  contentType: ["Image"],
  options: {
    framesBase64: null,
    deviceId: "...",
  },
}

export const sendNote = async () => {
  const res = await client.request(
    gql\`
            // copypasta the mutation
        \`,
    variables
  )

  console.log(res)
}
`}</code></pre>
    <p><inlineCode parentName="p">{`sendNote`}</inlineCode>{` is an async method invoked by AWS Lambda as a cloud function. It takes the initialized and authenticated `}<inlineCode parentName="p">{`GraphQLClient`}</inlineCode>{`, feeds it the same mutation and variables we had before, prints the result.`}</p>
    <p>{`Yes I pasted the whole base64 string for a 16KB image. Redacted 😅`}</p>
    <p>{`Configure in `}<inlineCode parentName="p">{`serverless.yml`}</inlineCode>{` as a function with no triggers.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`# serverless.yml
service: lovebox-lambda

provider:
  name: aws
  runtime: nodejs12.x
  stage: dev

functions:
  sendNote:
    handler: dist/lovebox.sendNote

package:
  exclude:
    - node_modules/typescript/**
    - node_modules/@types/**
`}</code></pre>
    <p>{`Name the project `}<inlineCode parentName="p">{`lovebox-lambda`}</inlineCode>{`, set basic provider config, declare a function, exclude typescript cruft on deploy.`}</p>
    <p>{`Later we'll add a cronjob trigger.`}</p>
    <h2 {...{
      "id": "step-\u00106-test-your-aws-lambda-locally"
    }}>{`Step 6: Test your AWS Lambda locally`}</h2>
    <pre><code parentName="pre" {...{}}>{`$ sls invoke local -f sendNote
`}</code></pre>
    <p><video parentName="p" {...{
        "style": {
          "margin": "auto auto",
          "display": "block",
          "maxWidth": "80%"
        },
        "autoPlay": true,
        "loop": true,
        "muted": true,
        "playsInline": true,
        "loading": "lazy"
      }}>{`
            `}<source parentName="video" {...{
          "src": "https://media2.giphy.com/media/26xBLChY6dbXtwhBm/giphy-loop.mp4?cid=7cf28b0frh877u0kqx0c31knjri80j5dm3t0byt7qnbzykuq&rid=giphy-loop.mp4&ct=g",
          "type": "video/mp4"
        }}></source>{`
        `}</video></p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Well shit that’s satisfying `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/codeWithSwiz?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#codeWithSwiz`}</a>{` `}<a parentName="p" {...{
          "href": "https://t.co/j5UYUAl6L5"
        }}>{`pic.twitter.com/j5UYUAl6L5`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/1364050018064162824"
      }}>{`February 23, 2021`}</a></blockquote>
    <p>{`It worked! 🥳`}</p>
    <p>{`Next episode we'll take this lambda, hook it up to an S3 bucket, and automate the shit out of my boyfriend duties.`}</p>
    <p>{`Cheers,`}<br />{`
~Swizec`}</p>
    <p>{`[sparkjoy|code-with-swiz-24-lovebox1]`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      